import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import api from "../lib/api";
import { Stars } from "./Stars";

export function ProductReviews({ productId }) {
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/products/${productId}/reviews`).then((r) => setData(r.data)); }, [productId]);
  if (!data) return null;
  return (
    <section className="mt-20" data-testid="product-reviews">
      <div className="flex flex-wrap items-end justify-between gap-4 border-b border-[#e5e5e5] pb-6">
        <div>
          <div className="overline text-[#d4af37]">From readers</div>
          <h2 className="font-serif text-3xl text-[#0a192f] mt-2">Testimonies</h2>
        </div>
        {data.count > 0 ? (
          <div className="flex items-center gap-3" data-testid="reviews-summary">
            <Stars value={data.average} size="w-5 h-5" testId="reviews-avg-stars" />
            <span className="font-serif text-2xl text-[#0a192f]">{data.average.toFixed(1)}</span>
            <span className="text-sm text-[#4a4a4a]">· {data.count} review{data.count === 1 ? "" : "s"}</span>
          </div>
        ) : <p className="text-sm text-[#4a4a4a]" data-testid="reviews-empty">Be the first to share what this meant to you — reviews open from My Library after purchase.</p>}
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-8">
        {data.reviews.map((r) => (
          <figure key={r.id} data-testid={`review-${r.id}`} className="card-flat p-6 relative">
            <Quote className="w-6 h-6 text-[#d4af37]/40 absolute top-4 right-4" />
            <Stars value={r.rating} testId={`review-stars-${r.id}`} />
            <blockquote className="mt-4 text-[#1a1a1a] leading-relaxed">{r.text}</blockquote>
            <figcaption className="mt-4 text-sm text-[#4a4a4a]"><span className="font-semibold text-[#0a192f]">{r.name}</span> · verified buyer · {new Date(r.created_at).toLocaleDateString()}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
